module.exports = __webpack_public_path__ + "res/ic_menu_settings_s.56c45a693e9c79b8e19a5487be7af5b3.png";